module.exports = __webpack_public_path__ + "static/media/zero-waste.525cd3b7.png";